<div mat-dialog-content>
    <div class="view-control">
        <button mat-fab mat-dialog-close color="warn">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <ngx-doc-viewer *ngIf="!data.isPdf" [viewerUrl]="data.viewerUrl" [url]="data.url" viewer="url"
        [googleCheckContentLoaded]="true" [googleCheckInterval]="2000" [googleMaxChecks]="5"
        style="width: 100%; height: 90vh"></ngx-doc-viewer>
    <ngx-extended-pdf-viewer *ngIf="data.isPdf" useBrowserLocale="true" [printResolution]="300" [src]="data.url"
        zoom="100%" height="90vh">
    </ngx-extended-pdf-viewer>
</div>